var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50016 20.5837H9.75016V15.167C9.75016 14.86 9.85416 14.6029 10.0622 14.3957C10.2702 14.1884 10.5273 14.0844 10.8335 14.0837H15.1668C15.4738 14.0837 15.7312 14.1877 15.9392 14.3957C16.1472 14.6037 16.2509 14.8608 16.2502 15.167V20.5837H19.5002V10.8337L13.0002 5.95866L6.50016 10.8337V20.5837ZM4.3335 20.5837V10.8337C4.3335 10.4906 4.41041 10.1656 4.56425 9.85866C4.71808 9.55171 4.93005 9.29894 5.20016 9.10032L11.7002 4.22533C12.0793 3.93644 12.5127 3.79199 13.0002 3.79199C13.4877 3.79199 13.921 3.93644 14.3002 4.22533L20.8002 9.10032C21.071 9.29894 21.2833 9.55171 21.4372 9.85866C21.591 10.1656 21.6676 10.4906 21.6668 10.8337V20.5837C21.6668 21.1795 21.4545 21.6897 21.0298 22.1144C20.6052 22.5391 20.0953 22.751 19.5002 22.7503H15.1668C14.8599 22.7503 14.6028 22.6463 14.3955 22.4383C14.1882 22.2303 14.0842 21.9732 14.0835 21.667V16.2503H11.9168V21.667C11.9168 21.9739 11.8128 22.2314 11.6048 22.4394C11.3968 22.6474 11.1397 22.751 10.8335 22.7503H6.50016C5.90433 22.7503 5.39444 22.5384 4.9705 22.1144C4.54655 21.6905 4.33422 21.1802 4.3335 20.5837Z",
    fill: "#EE5B3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFooter);
export default __webpack_public_path__ + "static/media/homeFooter.8bfbfc79ea6828141239cac966f0a570.svg";
export { ForwardRef as ReactComponent };